import { render } from "./product-comparison.vue?vue&type=template&id=798eba48"
import script from "./product-comparison.vue?vue&type=script&lang=js"
export * from "./product-comparison.vue?vue&type=script&lang=js"

import "./product-comparison.vue?vue&type=style&index=0&id=798eba48&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__